/**
 * RizoFino Header Scroll Behavior
 * Phase B — Transparent → Solid Espresso transition
 */

(function() {
  'use strict';

  // Only run on homepage where transparent header is active
  const isHomepage = document.body.dataset.pageType === 'index' || 
                     window.location.pathname === '/' ||
                     window.location.pathname === '/index';
  
  if (!isHomepage) return;

  // Check if hero with allow-transparent-header exists
  const heroSection = document.querySelector('.shopify-section:first-child [allow-transparent-header]');
  if (!heroSection) return;

  const header = document.querySelector('.header');
  if (!header) return;

  const SCROLL_THRESHOLD = 12; // transition as soon as the page begins moving
  let isSolid = false;

  function updateHeaderState() {
    const scrollY = window.scrollY || window.pageYOffset;
    const shouldBeSolid = scrollY > SCROLL_THRESHOLD;

    if (shouldBeSolid === isSolid) return;
    isSolid = shouldBeSolid;

    if (isSolid) {
      header.classList.add('is-solid');
      header.setAttribute('data-scroll-state', 'solid');
    } else {
      header.classList.remove('is-solid');
      header.removeAttribute('data-scroll-state');
    }
  }

  // Throttled scroll handler
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        updateHeaderState();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // Initial check
  updateHeaderState();

  // Also check on resize (header height may change)
  window.addEventListener('resize', function() {
    updateHeaderState();
  });

})();
